import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Layout } from "antd";

// project import
import Sidebar from "./Sidebar";
import Header from "./Header";
import { openDrawer } from "store/reducers/menu";
import Footer from "./Footer";
import useConfig from "hooks/useConfig";

const { Content } = Layout;

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
  const dispatch = useDispatch();
  const { container } = useConfig();
  const { drawerOpen } = useSelector((state) => state.menu);

  const [collapsed, setCollapsed] = useState(!drawerOpen);

  const handleDrawerToggle = () => {
    setCollapsed(!collapsed);
    dispatch(openDrawer({ drawerOpen: collapsed }));
  };

  useEffect(() => {
    setCollapsed(!drawerOpen);
  }, [drawerOpen]);

  return (
    <Layout className="min-h-screen">
      {/* Sidebar */}
      <Sidebar collapsed={collapsed} onCollapse={handleDrawerToggle} />

      {/* Main Content - Fixed margin since sidebar is always minimized (icon menu) */}
      <Layout
        className="transition-all duration-300 flex flex-col"
        style={{ marginLeft: 80, minHeight: '100vh' }}
      >
        {/* Header */}
        <Header />

        {/* Content Area */}
        <Content className="bg-gray-50 flex-1">
          {/* Page Content */}
          <div className={`p-4 ${container ? "mx-auto" : ""}`}>
            <Outlet />
          </div>
        </Content>

        {/* Footer */}
        <Footer />
      </Layout>
    </Layout>
  );
};

export default MainLayout;
